import React from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
import withStyles from "@mui/styles/withStyles";
const TRANSACTION_REQUESTED = "requested";
const TRANSACTION_PAID = "paid";
const TRANSACTION_CANCELLED = "cancelled";
const TRANSACTION_AVAILABLE = "available";
const TRANSACTION_FAILED = "failed";
const TRANSACTION_IN_PROGRESS = "in_progress";
const TRANSACTION_REQ_APPROVAL = "req_approval";
const TransactionState = ({
  classes,
  state
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: `${classes.box} ${classes[state]}`
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "inherit",
    align: "center",
    className: classes.title
  }, state));
};
const styles = theme => ({
  box: {
    borderRadius: 4,
    padding: 4,
    color: "#fff"
  },
  title: {
    fontWeight: 700
  },
  [TRANSACTION_AVAILABLE]: {
    backgroundColor: theme.palette.secondary.main
  },
  [TRANSACTION_REQUESTED]: {
    backgroundColor: theme.palette.primary.main
  },
  [TRANSACTION_PAID]: {
    backgroundColor: "#92d36e" //green
  },
  [TRANSACTION_CANCELLED]: {
    backgroundColor: theme.palette.error.main
  },
  [TRANSACTION_FAILED]: {
    color: "unset",
    backgroundColor: theme.palette.contrast.light
  },
  [TRANSACTION_IN_PROGRESS]: {
    backgroundColor: theme.palette.primary.light
  },
  [TRANSACTION_REQ_APPROVAL]: {
    backgroundColor: theme.palette.primary.main
  }
});
export default withStyles(styles)(TransactionState);
TransactionState.propTypes = {
  classes: PropTypes.object.isRequired,
  state: PropTypes.string.isRequired
};